import { Component, HostListener, inject, OnInit, OnDestroy, signal, Input, EventEmitter, Output, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JobsService } from '../jobs/jobs.service';
import { ISqlJob } from '../jobs/sql-job.interface';
import { Confirmation, ConfirmationService, MessageService } from 'primeng/api';
import { Observable, Subject, firstValueFrom } from 'rxjs';
import { Loading } from 'notiflix';
import { AuthService } from '../auth/auth.service';
import { NotesService } from '../notes/notes.service';
import { IFormState } from '../forms/inspection-form/inspection-form.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InspectionFormComponent } from '../forms/inspection-form/inspection-form.component';
import { JOB_STATUS } from '../jobs/job-status.enum';
import { InspectionFormService } from '../forms/inspection-form/inspection-form.service';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-inspection',
  templateUrl: './inspection.component.html',
  styleUrls: ['./inspection.component.scss']
})
export class InspectionComponent implements OnInit {
  canNavigateAwaySubject: Subject<boolean> = new Subject<boolean>();

  scJob: ISqlJob = {} as ISqlJob;
  isLoading = true;
  
  hasUnsavedChanges = false;
  hasUnsavedPhotoChanges = false;  //todo review deeply if we can remove this two 
  hasUnsavedFormChanges = false; 
  isInspectionImmutable = false;
  formState: IFormState = {} as IFormState;
  formStateEvent: any;
  immutableInspectionStatusIds = [1, 3, 6, 7, 8, 9];
  isLinkValid = false;
  hasPhotos = signal<boolean>(false);
  hasRequiredPhotos = signal<boolean>(true);
  isFormClosed = signal<boolean>(false);
  isSaveFinal = signal<boolean>(false);
  pageTitle = 'Invalid SiteCheck Inspection Form Link';
  viewOnly = false;
  editTimestamp: Date|null = null;
  JOB_STATUS = JOB_STATUS;

  @HostListener('window:beforeunload', ['$event'])
  public onPageUnload($event: BeforeUnloadEvent): string | void {
    if (this.hasUnsavedChanges) {
      return 'You have unsaved changes. Are you sure you want to leave?';
    }
  }

  private messageService = inject(MessageService);
  private notesService = inject(NotesService);

  @ViewChild('inspectionFormComponent') inspectionFormComponent!: InspectionFormComponent;

  constructor(private activatedRoute: ActivatedRoute,
              private confirmationService: ConfirmationService,
              // private router: Router,
              private jobsService: JobsService,
              private authService: AuthService,
              public ref: DynamicDialogRef,
              public config: DynamicDialogConfig,
              private inspectionFormService: InspectionFormService,
              private cdr: ChangeDetectorRef
              ) { }

  ngOnInit(): void {
    if(this.config?.data?.job?.scJobId) {
      this.scJob = this.config.data.job;
      if (this.scJob.scJobStatusId === JOB_STATUS.DELIVERED || this.scJob.scJobStatusId === JOB_STATUS.READY_TO_DELIVER) {
        this.viewOnly = true;
      }
      this.pageTitle = '';
      this.isInspectionImmutable = false;
      this.isLinkValid = true;
      this.isLoading = false;
      this.editTimestamp = new Date();
    } else {
      // todo: review and remove old code for rep guest access
      // const jobId = this.activatedRoute.snapshot.paramMap.get('jobId') || '';
      // const token = this.activatedRoute.snapshot.paramMap.get('token') || '';
      // this.jobsService.getScJobByJobId(jobId)
      //   .then(async scJob => {
      //     if (scJob) {
      //       // @ts-ignore
      //       this.scJob = scJob;
      //       this.pageTitle = `CSI/SiteCheck Inspection Submission for Job # ${scJob.scJobId}`;
      //       this.isInspectionImmutable = this.immutableInspectionStatusIds.includes(this.scJob.scJobStatusId);
      //       this.isLinkValid = true;
      //       await this.authService.login('sitecheck-guest2', '1234+Five');
      //     }
      //     this.isLoading = false;
      //   });
    }
  }

  //replaced by a boolean variable
  // hasUnsavedChanges(): boolean {
  //   return this.hasUnsavedFormChanges || this.hasUnsavedPhotoChanges;
  // }

  closeDialog() {
    if (this.viewOnly || !this.hasUnsavedChanges) {
      this.ref.close();
      return;
    }
    this.confirmationService.confirm({
      key: 'inspectionConfirmDialog',
      message: `Any unsaved changes will be lost. Are you sure you want to close the inspection form?`,
      accept: () => {
        this.isFormClosed.set(true);
        this.ref.close();
      }
    });
  }

  async qcSubmit() {
    // validate formio form before submission
    const formComponent = this.inspectionFormComponent.getFormioInstance();
    
    const isValid = formComponent.formio.checkValidity(null, true);
    if (!isValid) {
      const errors = formComponent.formio.errors;
      await this.inspectionFormService.acknowledgeErrors(errors);
      formComponent.formio.showErrors(errors);
      return;
    }

    const confirmed = await this.inspectionFormService.confirmAction(
      'Are you sure you want to submit this job for QC review?'
    );

    if (!confirmed) {
      return;
    }

    // const formComponent = this.inspectionFormComponent.getFormioInstance();
    try {
      const updatedJob = await this.inspectionFormService.submitToQc(this.config.data.job.jobId, this.editTimestamp, formComponent);
      if (updatedJob) {
        this.scJob.scJobStatusId = JOB_STATUS.QC;
        this.isSaveFinal.set(true);
      }

    } catch (error) {
      console.error('Error submitting to QC', error);
    } finally {
      this.ref.close();
    }
  }

  async saveForm() {
    try {
      const formComponent = this.inspectionFormComponent.getFormioInstance();
      const job = await this.inspectionFormService.saveInspectionForm(this.config.data.job.jobId, this.editTimestamp, formComponent);
      this.cdr.detectChanges(); //shoud be removed ?
      this.hasUnsavedChanges = false;
    } catch (error) {
      // Error handling is done in the service
    }
  }

  // canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
  //   if (this.hasUnsavedChanges()) {
  //     let work = `work`;
  //     if (this.hasUnsavedFormChanges && this.hasUnsavedPhotoChanges) {
  //       work = 'photos and inspection form changes';
  //     } else if (this.hasUnsavedFormChanges && !this.hasUnsavedPhotoChanges) {
  //       work = `inspection form changes`;
  //     } else if (this.hasUnsavedPhotoChanges && !this.hasUnsavedFormChanges) {
  //       work = `photo changes`;
  //     }
  //     this.confirmationService.confirm({
  //       key: 'inspectionConfirmDialog',
  //       message: `It appears you have unsaved ${work}, are you sure you want to leave this screen?`,
  //       defaultFocus: 'reject',
  //       closeOnEscape: true,
  //       accept: () => {
  //         this.canNavigateAwaySubject.next(true);
  //       },
  //       reject: () => {
  //         this.canNavigateAwaySubject.next(false);
  //       }
  //     });
  //     return this.canNavigateAwaySubject;
  //   }
  //   return true;
  // }

  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    console.log('canDeactivate called');
    if (this.hasUnsavedChanges) {
      this.confirmationService.confirm({
        key: 'inspectionConfirmDialog',
        message: `It appears you have unsaved changes, are you sure you want to leave this screen?`,
        defaultFocus: 'reject',
        closeOnEscape: true,
        accept: () => {
          this.canNavigateAwaySubject.next(true);
        },
        reject: () => {
          this.canNavigateAwaySubject.next(false);
        }
      });
      return this.canNavigateAwaySubject;
    }
    return true;
  }

  formStateChange(event: any) {
    this.formStateEvent = event;
    this.hasUnsavedChanges=true;
  }

  editTimestampChange(event: Date) {
    this.editTimestamp = event;
  }

}
